<div class="loader" [style.min-height]="diameter * 2 + 'px'">
  <mat-spinner [style.height]="diameter + 'px'"
               [style.width]="diameter + 'px'"
               [style.left]="'calc(50% -' + diameter / 2 + 'px)'"
               [style.top]="'calc(50% -' + diameter / 2 + 'px)'"
               [diameter]="diameter"
               [strokeWidth]="strokeWidth"></mat-spinner>
</div>
